import { useState, useEffect } from 'react'
import { getAllApplications, deleteApplicationWithId } from './../../../../../api'
import './candidateApplication.css'

function CandidateApplication(props){
  const [allApplications, setAllApplications] = useState([])
  useEffect(async () => {
    const response = await getAllApplications();
    setAllApplications(response.data.applications)
  }, [])

  const handleDelete = async (event, appId) => {
    event.preventDefault()
    event.target.disabled = true

    const { data } = await deleteApplicationWithId(appId)
    if (data.success && allApplications) {
      const newAppData = allApplications.filter(application => application._id !== data.application._id)
      event.target.disabled = false
      setAllApplications(newAppData)
    } else {
      // Send Error Message
      event.target.disabled = false
    }

  }

  return(
    <>
      <h2>Candiate Application</h2>
      <div className="table__container">
        <table className="table">
          <tr  className="table__header">
            <th>Job ID</th>
            <th>Candiate Name</th>
            <th>Phone No</th>
            <th>Mail ID</th>
            <th>Resume</th>
            <th>Delete</th>

          </tr>
          {allApplications ? allApplications.map((data, index) => {
            return (
              <tr className="table__row" key={index}>
                <td>{data._id}</td>
                <td>{data.name}</td>
                <td>{data.contactNo}</td>
                <td>{data.email}</td>
                <td><a className="resume" href={data.resume}>Resume</a></td>
                <td><button onClick={(e) => handleDelete(e, data._id)}>delete</button></td>
              </tr>
            )
          }) : <></>}
          {/* <tr className="table__row">
            <td>011</td>
            <td>john doe</td>
            <td>5552224646</td>
            <td>johndoe@example.com</td>
            <td>image</td>
          </tr>
          <tr className="table__row">
          <td>012</td>
          <td>john doe</td>
          <td>5552224646</td>
          <td>johndoe@example.com</td>
          <td>image</td>
          </tr> */}
        </table>
      </div>
    </>
  )
}

export default CandidateApplication
